import { render, staticRenderFns } from "./RegisterDashboard.vue?vue&type=template&id=234e6746"
import script from "./RegisterDashboard.vue?vue&type=script&lang=js"
export * from "./RegisterDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports